import React, { useState } from 'react';

// Menampilkan tautan "Lihat lampiran" yang membuka popup preview
// (gambar / video) beserta tombol Download. Self-contained: setiap baris
// tabel punya instance & state sendiri.
const fileNameFromUrl = (url) => {
  try {
    const clean = url.split('?')[0];
    const parts = clean.split('/');
    return parts[parts.length - 1] || 'lampiran';
  } catch (e) {
    return 'lampiran';
  }
};

const extOf = (url) => {
  const name = fileNameFromUrl(url).toLowerCase();
  const dot = name.lastIndexOf('.');
  return dot >= 0 ? name.substring(dot + 1) : '';
};

const IMAGE_EXT = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg'];
const VIDEO_EXT = ['mp4', 'webm', 'ogg', 'mov', 'm4v'];

export default function AttachmentModal({ url }) {
  const [open, setOpen] = useState(false);
  const [downloading, setDownloading] = useState(false);

  if (!url) return <span>-</span>;

  const ext = extOf(url);
  const isImage = IMAGE_EXT.includes(ext);
  const isVideo = VIDEO_EXT.includes(ext);
  const fileName = fileNameFromUrl(url);

  const handleDownload = async () => {
    setDownloading(true);
    try {
      const res = await fetch(url);
      const blob = await res.blob();
      const objectUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = objectUrl;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(objectUrl);
    } catch (e) {
      // Fallback: buka di tab baru bila fetch gagal (mis. CORS).
      window.open(url, '_blank', 'noopener,noreferrer');
    }
    setDownloading(false);
  };

  return (
    <>
      <a
        onClick={(e) => {
          e.preventDefault();
          setOpen(true);
        }}
        href={url}
        style={{ color: '#2f6fed', textDecoration: 'underline', cursor: 'pointer' }}
      >
        Lihat lampiran
      </a>

      {open && (
        <div
          onClick={() => setOpen(false)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0,0,0,0.6)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 2000,
            padding: 20,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: '#fff',
              borderRadius: 10,
              maxWidth: '90vw',
              maxHeight: '90vh',
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden',
              boxShadow: '0 10px 40px rgba(0,0,0,0.3)',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '12px 16px',
                borderBottom: '1px solid #eee',
              }}
            >
              <span
                style={{
                  fontWeight: 700,
                  fontSize: 14,
                  color: '#16181d',
                  maxWidth: '60vw',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {fileName}
              </span>
              <span
                onClick={() => setOpen(false)}
                style={{ cursor: 'pointer', fontSize: 22, lineHeight: 1, color: '#888', padding: '0 4px' }}
              >
                ×
              </span>
            </div>

            <div
              style={{
                padding: 16,
                overflow: 'auto',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: '#f5f5f5',
                minHeight: 120,
              }}
            >
              {isImage && (
                <img
                  src={url}
                  alt={fileName}
                  style={{ maxWidth: '100%', maxHeight: '70vh', objectFit: 'contain' }}
                />
              )}
              {isVideo && (
                <video
                  src={url}
                  controls
                  style={{ maxWidth: '100%', maxHeight: '70vh' }}
                />
              )}
              {!isImage && !isVideo && (
                <div style={{ textAlign: 'center', color: '#5a6475', padding: 24 }}>
                  <div style={{ fontSize: 40, marginBottom: 8 }}>📎</div>
                  <div>Preview tidak tersedia untuk tipe file ini.</div>
                  <div style={{ fontSize: 12, marginTop: 4 }}>Gunakan tombol Download di bawah.</div>
                </div>
              )}
            </div>

            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: 10,
                padding: '12px 16px',
                borderTop: '1px solid #eee',
              }}
            >
              <button
                className="btn btn-secondary"
                onClick={() => setOpen(false)}
              >
                Tutup
              </button>
              <button
                className="btn btn-primary"
                onClick={handleDownload}
                disabled={downloading}
              >
                {downloading ? 'Mengunduh...' : '⭳ Download'}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
